import { makeStyles } from '@material-ui/core/styles';
import theme from 'theme';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
  },
  cursorDefault: {
    cursor: 'pointer',
  },
  seeMore: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontWeight: theme.typography.fontWeightMedium,
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  switchLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
  },
}));

const tableStyles = {
  rows: {
    style: {
      borderBottom: `1px solid ${theme.palette.tables.border}`,
    },
  },
};

export { useStyles, tableStyles };
